const initialState = {
    doctorPermissionsApproval: {},
    doctorListsApproval: [],
    doctorViewListsApproval: [],
    doctorDetailListsApproval: [],
    doctorTypeDataApproval: [],
    doctorTypeApproval: [],
    hospitalListApproval: [],
    doctorStatusApproval: [],
    changedDoctorStatusApproval: [],
    changedDoctorTypeStatusApproval: [],
    createdDoctorIDApproval: '',
    doctorTypeCountApproval: 0,
    loadingDoctorCountApproval: false,
    loadingDoctorTypeApproval: false,
    loadingHospitalListApproval: false,
    loadingDoctorGrievanceApproval: false,
    loadingDoctorBlacklistApproval: false,
    loadingDoctorAlertApproval: false,
    errorsDoctorApproval: {},
    errorsDoctorTypeApproval: {},
    errorsDoctorRegisterApproval: {},
    errorsDoctorFacilityApproval: {},
    errorsSocialmediaApproval: {},
    errorsDoctorGrievanceApproval: {},
    errorsDoctorBlacklistApproval: {},
    errorsDoctorAlertApproval: {},
};

const doctorReducerApproval = (state = initialState, action) => {
    switch (action.type) {
        case "GET_DOCTORLIST_PENDING_APPROVAL":
        case "DOCTOR_TYPE_DATA_PENDING_APPROVAL":
            return { ...state, loadingDoctorTypeApproval: true, };
        case "HOSPITAL_LIST_PENDING_APPROVAL":
            return { ...state, loadingHospitalListApproval: true, };
        case "ADD_DOCTOR_TYPE_PENDING_APPROVAL":
            return { ...state, loadingDoctorTypeApproval: true, };
        case "UPDATE_DOCTOR_SOCIALMEDIA_PENDING_APPROVAL":
        case "ADD_DOCTOR_PENDING_APPROVAL":
        case "UPDATE_DOCTOR_PENDING_APPROVAL":
        case "DOCTOR_ATTACH_PENDING_APPROVAL":
        case "UPDATE_DOCTOR_STATUS_PENDING":
        case "DELETE_DOCTOR_PENDING_APPROVAL":
        case "GET_DOCTORLISTBYID_PENDING_APPROVAL":
        case "GET_DOCTORVIEWBYID_PENDING_APPROVAL":
            return { ...state, loadingDoctorCountApproval: true, errorsDoctorApproval: {} };
        case "GET_DOCTOR_DETAIL_LISTBYID_PENDING_APPROVAL":
            return { ...state, loadingDoctorCountApproval: true, errorsDoctorApproval: {} };
        case "DOCTOR_GRIEVANCE_PENDING_APPROVAL":
            return { ...state, loadingDoctorGrievanceApproval: true, errorsDoctorGrievanceApproval: {} };
        case "DOCTOR_BLACKLIST_PENDING_APPROVAL":
            return { ...state, loadingDoctorBlacklistApproval: true, errorsDoctorBlacklistApproval: {} };
        case "DOCTOR_ALERT_PENDING_APPROVAL":
            return { ...state, loadingDoctorAlertApproval: true, errorsDoctorAlertApproval: {} };
        case "DOCTOR_REGISTRATION_PENDING_APPROVAL":
            return { ...state, loadingDoctorCountApproval: true, errorsDoctorRegisterApproval: {} };

        case "GET_DOCTORLIST_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingDoctorCountApproval: false,
                //doctorListsApproval: action.payload,
                doctorCountApproval: action.countApproval,
                doctorPermissionsApproval: action.permissionsApproval,
            };

        case "DOCTOR_TYPE_DATA_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingDoctorTypeApproval: false,
                doctorTypeDataApproval: action.payload.data,
                doctorTypeCountApproval: action.countApproval,
            };
        case "HOSPITAL_LIST_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingHospitalListApproval: false,
                hospitalListApproval: action.payload.data,
            };
        case "ADD_DOCTOR_TYPE_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingDoctorTypeApproval: false,
                changedDoctorTypeStatusApproval: action.payload,
                errorsDoctorTypeApproval: {},
            };

        case "ADD_DOCTOR_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingDoctorCountApproval: false,
                changedDoctorStatusApproval: action.payload,
                //doctorListsApproval: action.payload?.data,
                createdDoctorIDApproval: action.payload?.data?.id || state.createdDoctorIDApproval,
                errorsDoctorApproval: {},
            };
        case "UPDATE_DOCTOR_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingDoctorCountApproval: false,
                changedDoctorStatusApproval: action.payload,
                //doctorListsApproval: action.payload?.data,
                createdDoctorIDApproval: action.payload?.data?.id || state.createdDoctorIDApproval,
                errorsDoctorApproval: {},
            };

        case "UPDATE_DOCTOR_SOCIALMEDIA_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingDoctorCountApproval: false,
                changedDoctorStatusApproval: action.payload,
                //doctorListsApproval: action.payload?.data,
                createdDoctorIDApproval: action.payload?.data?.doctorId || state.createdDoctorIDApproval,
                errorsSocialmediaApproval: {},
            };

        case "DOCTOR_REGISTRATION_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingDoctorCountApproval: false,
                changedDoctorStatusApproval: action.payload,
                //doctorListsApproval: action.payload?.data,
                createdDoctorIDApproval: action.payload?.data?.doctorId || state.createdDoctorIDApproval,
                errorsDoctorRegisterApproval: {},
            };
        case "DOCTOR_ATTACH_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingDoctorCountApproval: false,
                changedDoctorStatusApproval: action.payload,
                //doctorListsApproval: action.payload?.data,
                createdDoctorIDApproval: action.payload?.data?.doctorId || state.createdDoctorIDApproval,
                errorsDoctorFacilityApproval: {},
            };
        case "DOCTOR_GRIEVANCE_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingDoctorGrievanceApproval: false,
                //doctorListsApproval: action.payload?.data,
                changedDoctorStatusApproval: action.payload,
                errorsDoctorGrievanceApproval: {},
            };
        case "DOCTOR_BLACKLIST_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingDoctorBlacklistApproval: false,
                //doctorListsApproval: action.payload?.data,
                changedDoctorStatusApproval: action.payload,
                errorsDoctorBlacklistApproval: {},
            };
        case "DOCTOR_ALERT_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingDoctorAlertApproval: false,
                //doctorListsApproval: action.payload?.data,
                changedDoctorStatusApproval: action.payload,
                errorsDoctorAlertApproval: {},
            };
        case "UPDATE_DOCTOR_STATUS_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingDoctorCountApproval: false,
                changedDoctorStatusApproval: action.payload,
                //doctorListsApproval: action.payload?.data,
                createdDoctorIDApproval: action.payload?.data?.id || state.createdDoctorIDApproval,
            };
        case "RESET_CREATED_DOCTOR_ID_APPROVAL":
            return {
                ...state,
                createdDoctorIDApproval: null,
            };

        case "GET_DOCTORLISTBYID_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingDoctorCountApproval: false,
                doctorListsApproval: action.payload,
            };

        case "GET_DOCTORVIEWBYID_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingDoctorCountApproval: false,
                doctorViewListsApproval: action.payload,
            };

        case "GET_DOCTOR_DETAIL_LISTBYID_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingDoctorCountApproval: false,
                doctorDetailListsApproval: action.payload,
            };

        case "DELETE_DOCTOR_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingDoctorCountApproval: false,
                changedDoctorStatusApproval: action.payload,
            };

        case "RESET_DELETE_DOCTORS_STATUS_APPROVAL":
            return {
                ...state,
                loadingDoctorCountApproval: false,
                changedDoctorStatusApproval: [],
                errorsDoctorApproval: {},
            };

        case "GET_DOCTORLIST_REJECTED_APPROVAL":
        case "DOCTOR_TYPE_DATA_REJECTED_APPROVAL":
            return {
                ...state,
                loadingDoctorTypeApproval: false,
                errorsDoctorApproval: action.payload,
            };
        case "HOSPITAL_LIST_REJECTED_APPROVAL":
            return {
                ...state,
                loadingHospitalListApproval: false,
                errorsDoctorApproval: action.payload,
            };
        case "ADD_DOCTOR_TYPE_REJECTED_APPROVAL":
            return {
                ...state,
                loadingDoctorTypeApproval: false,
                changedDoctorTypeStatusApproval: [],
                errorsDoctorTypeApproval: action.payload,
            };
        case "ADD_DOCTOR_REJECTED_APPROVAL":
            return {
                ...state,
                loadingDoctorCountApproval: false,
                errorsDoctorApproval: action.payload,
            };
        case "UPDATE_DOCTOR_SOCIALMEDIA_REJECTED_APPROVAL":
            return {
                ...state,
                loadingDoctorCountApproval: false,
                errorsSocialmediaApproval: action.payload,
            };
        case "DOCTOR_REGISTRATION_REJECTED_APPROVAL":
            return {
                ...state,
                loadingDoctorCountApproval: false,
                errorsDoctorRegisterApproval: action.payload,
            };
        case "DOCTOR_ATTACH_REJECTED_APPROVAL":
            return {
                ...state,
                loadingDoctorCountApproval: false,
                errorsDoctorFacilityApproval: action.payload,
            };
        case "DOCTOR_GRIEVANCE_REJECTED_APPROVAL":
            return {
                ...state,
                loadingDoctorGrievanceApproval: false,
                errorsDoctorGrievanceApproval: action.payload,
            };
        case "DOCTOR_BLACKLIST_REJECTED_APPROVAL":
            return {
                ...state,
                loadingDoctorBlacklistApproval: false,
                errorsDoctorBlacklistApproval: action.payload,
            };
        case "DOCTOR_ALERT_REJECTED_APPROVAL":
            return {
                ...state,
                loadingDoctorAlertApproval: false,
                errorsDoctorAlertApproval: action.payload,
            };
        case "UPDATE_DOCTOR_REJECTED_APPROVAL":
        case "UPDATE_DOCTOR_STATUS_REJECTED_APPROVAL":
        case "DELETE_DOCTOR_REJECTED_APPROVAL":
        case "GET_DOCTORLISTBYID_REJECTED_APPROVAL":
        case "GET_DOCTORVIEWBYID_REJECTED_APPROVAL":
            return {
                ...state,
                loadingDoctorCountApproval: false,
                errorsDoctorApproval: action.payload,
            };
        case "GET_DOCTOR_DETAIL_LISTBYID_REJECTED_APPROVAL":
            return {
                ...state,
                loadingDoctorCountApproval: false,
                errorsDoctorApproval: action.payload,
            };
        case "RESET_DELETE_DOCTOR_STATUS_APPROVAL":
            return {
                ...state,
                loadingDoctorCountApproval: false,
                loadingDoctorTypeApproval: false,
                loadingHospitalListApproval: false,
                loadingDoctorGrievanceApproval: false,
                loadingDoctorBlacklistApproval: false,
                loadingDoctorAlertApproval: false,
                errorsDoctorApproval: {},
                errorsDoctorTypeApproval: {},
                errorsDoctorRegisterApproval: {},
                errorsDoctorFacilityApproval: {},
                errorsSocialmediaApproval: {},
                errorsDoctorGrievanceApproval: {},
                errorsDoctorBlacklistApproval: {},
                errorsDoctorAlertApproval: {},
            };
        case "RESET_DOCTOR_STATE_APPROVAL":
            return { ...initialState };

        default:
            return state;
    }
};

export default doctorReducerApproval;
